/* eslint-disable react/jsx-boolean-value */
import React from 'react';
import {
  ButtonAction, sanitize,
} from '@honeycomb-npm/honeycomb-react';
import Blade from '../../shared/Blade/Blade';
import { BLADES } from '../../../constants';
import { content } from '../../../utils/contentUtils';
import { analyticsConstants } from '../../../constants/analyticsConstants';

import './GetStarted.scss';

export interface Props {
  visibility: boolean;
  completed: (blade: string) => void;
}

const GetStarted = ({
  visibility, completed,
}: Props) => {
  const {
    title, paragraphs, btnText,
  } = content[BLADES.getStarted];
  return (
    <Blade
      id={BLADES.getStarted}
      className="get-started"
      hasImage={true}
      shouldVerticalAlign={true}
      visibility={true}
      isGoToPreviousBlade={false}
    >
      <div className="get-started__wrapper">
        <div className="container pr-lg-5 mt-8">
          <div className="row">
            <div className="col-lg-9 col-md-12 px-4 mt-4">
              <img
                className="mw-100 mb-5"
                src="https://www.commbank.com.au/content/dam/commbank-assets/dp/PaymentDetails/OFI_Statements_Illustration.svg"
                alt=""
                width="420"
              />
              <h1>{title}</h1>
              <div dangerouslySetInnerHTML={sanitize(paragraphs)} />
              <div className="mt-4">
                <ButtonAction
                  id={analyticsConstants.ofiLanding}
                  onClick={() => completed(BLADES.getStarted)}
                  variant="default"
                >
                  {btnText}
                </ButtonAction>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Blade>
  );
};

export default GetStarted;
